import {Component, OnInit} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {DialogBase} from '@shared/helper/dialog-base';

export interface MenuDialogData {
    menus: MenuDialogItem[];
    descriptionHtml?: string;
    actionText?: string;
}

export interface MenuDialogItem extends Partial<MenuItem> {
    // [x: string]: any[];
    action: () => void;
}

@Component({
    selector: 'app-menu-dialog',
    template: `
        <p *ngIf="descriptionHtml" style="max-width: 400px;">
            <span class="p-5" [innerHTML]="descriptionHtml"></span>
        </p>
        <h5 *ngIf="actionText" class="text-center font-bold">
            {{ actionText }}
        </h5>
        <div class="flex flex-column gap-3 m-5">
            <button *ngFor="let item of menus"
                    pButton
                    type="button"
                    [label]="item.label"
                    [icon]="item.icon"
                    [disabled]="item.disabled"
                    class="p-button-raised"
                    [class]="item.styleClass"
                    (click)="onButtonClick(item)"
            >
            </button>
        </div>
    `,
    styles: []
})
export class MenuDialogComponent extends DialogBase<MenuDialogData, MenuDialogItem> implements OnInit {
    menus: MenuDialogItem[] = [];
    descriptionHtml: string;
    actionText: string;

    ngOnInit(): void {
        this.menus = this.data.menus ?? [];
        this.descriptionHtml = this.data.descriptionHtml;
        this.actionText = this.data.actionText;
    }

    onButtonClick(item: MenuDialogItem) {
        item.action();
        this.close(item);
    }
}
